import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../components/Footer";

export default function BajaAlerta() {
  const location = useLocation();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const productId = params.get("productId");
    const userId = params.get("userId");

    if (!productId || !userId) {
      setStatus("error");
      return;
    }

    fetch(
      `https://europe-west1-avisamesibaja-be02c.cloudfunctions.net/unsubscribeAlert?productId=${encodeURIComponent(productId)}&userId=${encodeURIComponent(userId)}`
    )
      .then((r) => r.json())
      .then((data) => setStatus(data.ok ? "ok" : "error"))
      .catch(() => setStatus("error"));
  }, [location.search]);

  return (
    <div style={{ padding: 20, fontFamily: "Arial, sans-serif" }}>
      <div style={{ maxWidth: 560, margin: "80px auto", textAlign: "center" }}>
        {status === "loading" && <p style={{ color: "#666" }}>Procesando tu solicitud...</p>}

        {status === "ok" && (
          <>
            <h2 style={{ color: "#222" }}>✅ Alerta desactivada</h2>
            <p style={{ color: "#555", lineHeight: 1.6 }}>
              Ya no recibirás más notificaciones de bajada de precio para este producto.
            </p>
            <p style={{ color: "#555" }}>
              Puedes volver a activarla en cualquier momento desde{" "}
              <a href="https://www.avisamesibaja.com" style={{ color: "#007bff" }}>
                tu cuenta
              </a>
              .
            </p>
          </>
        )}

        {status === "error" && (
          <>
            <h2 style={{ color: "#222" }}>⚠️ No se pudo procesar</h2>
            <p style={{ color: "#555", lineHeight: 1.6 }}>
              El enlace puede haber caducado o ser inválido. Accede a{" "}
              <a href="https://www.avisamesibaja.com" style={{ color: "#007bff" }}>
                tu cuenta
              </a>{" "}
              para gestionar tus alertas manualmente.
            </p>
            <p style={{ color: "#555" }}>
              ¿Necesitas ayuda?{" "}
              <a href="mailto:info@avisamesibaja.com" style={{ color: "#007bff" }}>
                info@avisamesibaja.com
              </a>
            </p>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}
